import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

// Define the Tooltip context interface
interface TooltipContextProps {
  // Home page Walkthrough start
  homeWalkThroughVisible: boolean;
  setHomeWalkThroughVisible: React.Dispatch<React.SetStateAction<boolean>>;
  tooltipVisible: boolean;
  setTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  homeTooltipVisible: boolean;
  setHomeTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  createEventTooltipVisible: boolean;
  setCreateEventTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  signupEventTooltipVisible: boolean;
  setSignupEventTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  ticketEventTooltipVisible: boolean;
  setTicketEventTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarTopTooltipVisible: boolean;
  setSidebarTopTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarBottomTooltipVisible: boolean;
  setSidebarBottomTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  searchTooltipVisible: boolean;
  setSearchTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  walletTooltipVisible: boolean;
  setWalletTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  chatTooltipVisible: boolean;
  setChatTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  notificationTooltipVisible: boolean;
  setNotificationTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  profileTooltipVisible: boolean;
  setProfileTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  resetTooltips: () => void;
  // Home page Walkthrough end

  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  totalSteps: number;
  setTotalSteps: React.Dispatch<React.SetStateAction<number>>;
  handleNextStep: () => void;

  // create event page Walkthrough start
  eventNameTooltipVisible: boolean;
  setEventNameTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  dateTimeTooltipVisible: boolean;
  setDateTimeTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  descriptionTooltipVisible: boolean;
  setDescriptionTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  deviceTooltipVisible: boolean;
  setDeviceTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  gamerIdTooltipVisible: boolean;
  setGamerIdTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  stakeTooltipVisible: boolean;
  setStakeTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  resetCreateEventTooltips: () => void;
  // create event page Walkthrough end

  // myevent page Walkthrough start
  commonMyEventTooltipVisible: boolean;
  setCommonMyEventTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  kallOutTooltipVisible: boolean;
  setKallOutTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  opponentTooltipVisible: boolean;
  setOpponentTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  watchingEventTooltipVisible: boolean;
  setWatchingEventTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  pastEventTooltipVisible: boolean;
  setPastEventTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  resetMyEventTooltips: () => void;
  // myevent page Walkthrough end

  // My profile Walkthrough start
  myProfileTooltipVisible: boolean;
  setMyProfileTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  profilePicTooltipVisible: boolean;
  setProfilePicTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  bioTooltipVisible: boolean;
  setBioTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  tokenBalanceTooltipVisible: boolean;
  setTokenBalanceTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  coinBalanceTooltipVisible: boolean;
  setCoinBalanceTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  dataTooltipVisible: boolean;
  setDataTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  buyBeltTooltipVisible: boolean;
  setBuyBeltTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  myGamesTooltipVisible: boolean;
  setMyGamesTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  convertBeltTooltipVisible: boolean;
  setConvertBeltTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  creditTooltipVisible: boolean;
  setCreditTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  rankingTooltipVisible: boolean;
  setRankingTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  proTipTooltipVisible: boolean;
  setProTipTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  resetMyProfileTooltips: () => void;
  // My profile Walkthrough end

  gameTooltipVisible: boolean;
  setGameTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  withoutStreamTooltipVisible: boolean;
  setWithoutStreamTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  youtubeStreamTooltipVisible: boolean;
  setYoutubeStreamTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  exclusiveTooltipVisible: boolean;
  setExclusiveTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
  settingTooltipVisible: boolean;
  setSettingTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

// Define the TooltipProvider props
interface TooltipProviderProps {
  children: ReactNode;
}

// Create the context
const TooltipContext = createContext<TooltipContextProps | undefined>(
  undefined
);

// TooltipProvider Component
export const TooltipProvider: React.FC<TooltipProviderProps> = ({
  children,
}) => {
  {
    /* Home tooltips */
  }
  const [homeWalkThroughVisible, setHomeWalkThroughVisible] =
    useState<boolean>(false);
  const [tooltipVisible, setTooltipVisible] = useState<boolean>(false);
  const [homeTooltipVisible, setHomeTooltipVisible] = useState<boolean>(false);
  const [createEventTooltipVisible, setCreateEventTooltipVisible] =
    useState<boolean>(false);
  const [signupEventTooltipVisible, setSignupEventTooltipVisible] =
    useState<boolean>(false);
  const [ticketEventTooltipVisible, setTicketEventTooltipVisible] =
    useState<boolean>(false);
  const [sidebarTopTooltipVisible, setSidebarTopTooltipVisible] =
    useState<boolean>(false);
  const [sidebarBottomTooltipVisible, setSidebarBottomTooltipVisible] =
    useState<boolean>(false);
  const [searchTooltipVisible, setSearchTooltipVisible] =
    useState<boolean>(false);
  const [walletTooltipVisible, setWalletTooltipVisible] =
    useState<boolean>(false);
  const [chatTooltipVisible, setChatTooltipVisible] = useState<boolean>(false);
  const [notificationTooltipVisible, setNotificationTooltipVisible] =
    useState<boolean>(false);
  const [profileTooltipVisible, setProfileTooltipVisible] =
    useState<boolean>(false);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [totalSteps, setTotalSteps] = useState<number>(5);
  const handleNextStep = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };
  {
    /* myevent tooltips */
  }
  const [commonMyEventTooltipVisible, setCommonMyEventTooltipVisible] =
    useState<boolean>(false);
  const [kallOutTooltipVisible, setKallOutTooltipVisible] =
    useState<boolean>(false);
  const [opponentTooltipVisible, setOpponentTooltipVisible] =
    useState<boolean>(false);
  const [watchingEventTooltipVisible, setWatchingEventTooltipVisible] =
    useState<boolean>(false);
  const [pastEventTooltipVisible, setPastEventTooltipVisible] =
    useState<boolean>(false);
  {
    /* my profile tooltips */
  }
  const [myProfileTooltipVisible, setMyProfileTooltipVisible] =
    useState<boolean>(false);
  const [profilePicTooltipVisible, setProfilePicTooltipVisible] =
    useState<boolean>(false);
  const [bioTooltipVisible, setBioTooltipVisible] = useState<boolean>(false);
  const [tokenBalanceTooltipVisible, setTokenBalanceTooltipVisible] =
    useState<boolean>(false);
  const [coinBalanceTooltipVisible, setCoinBalanceTooltipVisible] =
    useState<boolean>(false);
  const [dataTooltipVisible, setDataTooltipVisible] = useState<boolean>(false);
  const [buyBeltTooltipVisible, setBuyBeltTooltipVisible] =
    useState<boolean>(false);
  const [myGamesTooltipVisible, setMyGamesTooltipVisible] =
    useState<boolean>(false);
  const [convertBeltTooltipVisible, setConvertBeltTooltipVisible] =
    useState<boolean>(false);
  const [creditTooltipVisible, setCreditTooltipVisible] =
    useState<boolean>(false);
  const [rankingTooltipVisible, setRankingTooltipVisible] =
    useState<boolean>(false);
  const [proTipTooltipVisible, setProTipTooltipVisible] =
    useState<boolean>(false);

  {
    /* create event tooltips */
  }
  const [eventNameTooltipVisible, setEventNameTooltipVisible] =
    useState<boolean>(false);
  const [gameTooltipVisible, setGameTooltipVisible] = useState<boolean>(false);
  const [deviceTooltipVisible, setDeviceTooltipVisible] =
    useState<boolean>(false);
  const [gamerIdTooltipVisible, setGamerIdTooltipVisible] =
    useState<boolean>(false);
  const [descriptionTooltipVisible, setDescriptionTooltipVisible] =
    useState<boolean>(false);
  const [dateTimeTooltipVisible, setDateTimeTooltipVisible] =
    useState<boolean>(false);
  const [stakeTooltipVisible, setStakeTooltipVisible] =
    useState<boolean>(false);
  const [withoutStreamTooltipVisible, setWithoutStreamTooltipVisible] =
    useState<boolean>(false);
  const [youtubeStreamTooltipVisible, setYoutubeStreamTooltipVisible] =
    useState<boolean>(false);
  const [exclusiveTooltipVisible, setExclusiveTooltipVisible] =
    useState<boolean>(false);
  const [settingTooltipVisible, setSettingTooltipVisible] =
    useState<boolean>(false);
  {
    /* Home tooltips */
  }
  const resetTooltips = () => {
    setHomeWalkThroughVisible(false);
    setTooltipVisible(false);
    setHomeTooltipVisible(false);
    setCreateEventTooltipVisible(false);
    setSignupEventTooltipVisible(false);
    setTicketEventTooltipVisible(false);
    setSidebarTopTooltipVisible(false);
    setSearchTooltipVisible(false);
    setWalletTooltipVisible(false);
    setChatTooltipVisible(false);
    setNotificationTooltipVisible(false);
    setProfileTooltipVisible(false);
    setSidebarBottomTooltipVisible(false);
    setCurrentStep(0);
    setTotalSteps(5);
  };

  {
    /* myevent tooltips */
  }
  const resetMyEventTooltips = () => {
    setCommonMyEventTooltipVisible(false);
    setOpponentTooltipVisible(false);
    setKallOutTooltipVisible(false);
    setPastEventTooltipVisible(false);
    setWatchingEventTooltipVisible(false);
  };
  const resetMyProfileTooltips = () => {
    setMyProfileTooltipVisible(false);
    setProfilePicTooltipVisible(false);
    setBioTooltipVisible(false);
    setTokenBalanceTooltipVisible(false);
    setCoinBalanceTooltipVisible(false);
    setDataTooltipVisible(false);
    setBuyBeltTooltipVisible(false);
    setMyGamesTooltipVisible(false);
    setConvertBeltTooltipVisible(false);
    setCreditTooltipVisible(false);
    setRankingTooltipVisible(false);
    setProTipTooltipVisible(false);
  };

  const resetCreateEventTooltips = () => {
    setEventNameTooltipVisible(false);
    setGameTooltipVisible(false);
    setDeviceTooltipVisible(false);
    setGamerIdTooltipVisible(false);
    setDescriptionTooltipVisible(false);
    setDateTimeTooltipVisible(false);
    setStakeTooltipVisible(false);
    setWithoutStreamTooltipVisible(false);
    setYoutubeStreamTooltipVisible(false);
    setExclusiveTooltipVisible(false);
    setSettingTooltipVisible(false);
  };
  return (
    <TooltipContext.Provider
      value={{
        homeWalkThroughVisible,
        setHomeWalkThroughVisible,
        tooltipVisible,
        setTooltipVisible,
        homeTooltipVisible,
        setHomeTooltipVisible,
        createEventTooltipVisible,
        setCreateEventTooltipVisible,
        signupEventTooltipVisible,
        setSignupEventTooltipVisible,
        ticketEventTooltipVisible,
        setTicketEventTooltipVisible,
        sidebarTopTooltipVisible,
        setSidebarTopTooltipVisible,
        searchTooltipVisible,
        setSearchTooltipVisible,
        walletTooltipVisible,
        setWalletTooltipVisible,
        chatTooltipVisible,
        setChatTooltipVisible,
        notificationTooltipVisible,
        setNotificationTooltipVisible,
        profileTooltipVisible,
        setProfileTooltipVisible,
        sidebarBottomTooltipVisible,
        setSidebarBottomTooltipVisible,
        currentStep,
        setCurrentStep,
        totalSteps,
        setTotalSteps,
        handleNextStep,
        resetTooltips,
        commonMyEventTooltipVisible,
        setCommonMyEventTooltipVisible,
        kallOutTooltipVisible,
        setKallOutTooltipVisible,
        opponentTooltipVisible,
        setOpponentTooltipVisible,
        pastEventTooltipVisible,
        setPastEventTooltipVisible,
        watchingEventTooltipVisible,
        setWatchingEventTooltipVisible,
        resetMyEventTooltips,
        myProfileTooltipVisible,
        setMyProfileTooltipVisible,
        profilePicTooltipVisible,
        setProfilePicTooltipVisible,
        bioTooltipVisible,
        setBioTooltipVisible,
        tokenBalanceTooltipVisible,
        setTokenBalanceTooltipVisible,
        coinBalanceTooltipVisible,
        setCoinBalanceTooltipVisible,
        dataTooltipVisible,
        setDataTooltipVisible,
        buyBeltTooltipVisible,
        setBuyBeltTooltipVisible,
        myGamesTooltipVisible,
        setMyGamesTooltipVisible,
        convertBeltTooltipVisible,
        setConvertBeltTooltipVisible,
        creditTooltipVisible,
        setCreditTooltipVisible,
        rankingTooltipVisible,
        setRankingTooltipVisible,
        proTipTooltipVisible,
        setProTipTooltipVisible,
        resetMyProfileTooltips,
        eventNameTooltipVisible,
        setEventNameTooltipVisible,
        gameTooltipVisible,
        setGameTooltipVisible,
        deviceTooltipVisible,
        setDeviceTooltipVisible,
        gamerIdTooltipVisible,
        setGamerIdTooltipVisible,
        descriptionTooltipVisible,
        setDescriptionTooltipVisible,
        dateTimeTooltipVisible,
        setDateTimeTooltipVisible,
        stakeTooltipVisible,
        setStakeTooltipVisible,
        withoutStreamTooltipVisible,
        setWithoutStreamTooltipVisible,
        youtubeStreamTooltipVisible,
        setYoutubeStreamTooltipVisible,
        exclusiveTooltipVisible,
        setExclusiveTooltipVisible,
        settingTooltipVisible,
        setSettingTooltipVisible,
        resetCreateEventTooltips,
      }}
    >
      {children}
    </TooltipContext.Provider>
  );
};

// Custom Hook to use TooltipContext
export const useTooltips = () => {
  const context = useContext(TooltipContext);
  if (context === undefined) {
    throw new Error("useTooltips must be used within a TooltipProvider");
  }
  return context;
};
